import { useLocal } from '@/i18n/LocalContext'
import { getPreBaseData } from '@/request'
import { checkToken, getBindedPlayer } from '@/request/userServer'
import { logout } from '@/request/utils'
import { useStore } from '@/store'
import { closeLoading, loading, toast } from '@/utils'
import { useEffect, useRef } from 'react'
import { keyDataConsumeTimeReport } from '@/monitor'

export default function usePlayer() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const logined = state.login.logined
  const isBinded = state.login.userInfo.isBinded
  const isCodeBinded = state.login.userInfo.isCodeBinded
  const checked = state.login.userInfo.checked
  const pending = useRef(false)

  useEffect(() => {
    const _cancel = () => {}

    if (pending.current) return

    pending.current = true

    if (!logined) {
      getActivityData()
      return _cancel
    }

    loading()
    const tokenStartTime = Date.now()
    let tokenTime = -1
    checkToken()
      .then(() => {
        tokenTime = Date.now() - tokenStartTime
        setTimeout(() => {
          keyDataConsumeTimeReport({
            token: tokenTime,
          })
        }, 1)
        return getBindedPlayer()
      })
      .then((res) => {
        const data: Record<string, unknown> = {
          checked: 1,
          isBinded: res.isUserBind,
          isCodeBinded: res.isCodeBind,
          playerType: res.category,
        }

        if (res.isUserBind) {
          toast($t('登录成功'))
          data.playerId = res.playerId
          data.zoneId = res.zoneId
          data.serverId = res.serverId
          data.playerName = res.nickName
        } else {
          data.playerId = ''
          data.zoneId = res.zoneId
          data.serverId = ''
          data.playerName = ''
        }

        dispatch({
          type: 'bindPlayer',
          data,
        })
      })
      .catch(() => {
        dispatch({
          type: 'bindPlayer',
          data: {
            checked: 2,
          },
        })
        logout($t('请更换账号登录'), true)
      })
      .finally(() => {
        pending.current = false
        closeLoading()
      })

    return _cancel
  }, [logined])

  return { logined, isBinded, checked, isCodeBinded }

  function getActivityData() {
    loading()
    getPreBaseData()
      .then((data) => {
        dispatch({
          type: 'setBaseData',
          data,
        })
      })
      .finally(() => {
        pending.current = false
        closeLoading()
      })
  }
}
